import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { MarkerClusterer, SuperClusterAlgorithm } from '@googlemaps/markerclusterer';
import Geocode from 'react-geocode';
import Grid from '@material-ui/core/Grid';
import { CustomIconButton } from '../../../../Core/Controls/Inputs/Buttons/ButtonModal';
import InputAdornment from '@material-ui/core/InputAdornment';
import { InputText, SecondaryButton } from '../../../../Core/Controls';
import SearchIcon from '@material-ui/icons/Search';
import Checkbox from '@material-ui/core/Checkbox';
import { Typography } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import serviceLogo from '../../../../Marker/Service.png';
import recoveryLogo from '../../../../Marker/Recovery.png';
import closestLogo from '../../../../Marker/Closest.png';

import car_repair_amberLogo from '../../../../Marker/car_repair_amber.png';
import car_repair_redLogo from '../../../../Marker/car_repair_red.png';
import car_repair_greenLogo from '../../../../Marker/car_repair_green.png';

import locationLogo from '../../../../Marker/car_pin.png';
import hgvLogo from '../../../../Marker/hgv_pin.png';
import vanLogo from '../../../../Marker/van_pin.png';
import trailerLogo from '../../../../Marker/trailer_pin.png';
import busLogo from '../../../../Marker/bus_pin.png';
import redLogo from '../../../../Marker/redIcon.png';

let tempObj = {
    hgv: hgvLogo,
    van: vanLogo,
    trailer: trailerLogo,
    psv: busLogo,
    car: locationLogo
};

Geocode.setApiKey('AIzaSyC5WVAZAkE2SUN3G6aj4kvjhfWJjM_yC_w');
Geocode.setLanguage('en');
Geocode.setLocationType('ROOFTOP');
Geocode.enableDebug();

const GetAgentLocation2 = (props) => {
    // memoize vehicle category logo so it doesn't re-evaluate every render
    const vehcileCategoriesLogo = useMemo(() => {
        if (props.vehcileCategories && tempObj[props.vehcileCategories.toLowerCase()]) {
            return tempObj[props.vehcileCategories.toLowerCase()];
        } else {
            return tempObj['car'];
        }
    }, [props.vehcileCategories]);

    const google = window.google;
    const [state, setState] = useState({
        mapLocation: [],
        FilterList: [],
        tempFilterList: [],
        filterRecoveryAgent: [],
        serviceagent: true,
        recoveryAgent: false,
        location: props.location,
        isOpen: false,
        activeMarker: {},
        showingInfoWindow: false,
        currentLat: 53.15296,
        currentLang: -2.11704,
        arr_facilities: [],
        facilitiId: [],
        zoom: props.location ? 12 : 6
    });

    const deg2rad = (deg) => deg * (Math.PI / 180);

    // fetchCurrentLocation: memoized (stable ref) and robust facility parsing is used in other places.
    const fetchCurrentLocation = useCallback(() => {
        let FilterList = [];
        const tempArray = [...state.mapLocation];

        Geocode.fromAddress(state.location || 'CA81UR').then(
            (response) => {
                if (response) {
                    const { lat, lng } = response.results[0].geometry.location;
                    tempArray.forEach((l) => {
                        // keep icon assignment idempotent (don't repeatedly insert)
                        var R = 3958; // miles
                        var dLat = deg2rad(l[8] - lat);
                        var dLon = deg2rad(l[9] - lng);
                        var a =
                            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                            Math.cos(deg2rad(lat)) * Math.cos(deg2rad(l[8])) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
                        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                        var d = R * c; // Distance in miles

                        // assign icon (idempotent)
                        if (d < 10) {
                            l[11] = car_repair_greenLogo;
                        } else if (d > 10 && d < 20) {
                            l[11] = car_repair_amberLogo;
                        } else {
                            l[11] = car_repair_redLogo;
                        }

                        if (d < 1000) {
                            FilterList.push(l);
                        }
                    });

                    setState((st) => ({
                        ...st,
                        FilterList: FilterList,
                        tempFilterList: FilterList,
                        currentLat: lat,
                        currentLang: lng
                    }));
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }, [state.mapLocation, state.location]);

    // load static JSON files once
    useEffect(() => {
        let urls = ['/agent_facilities.json', '/latlang.json'];
        Promise.all(urls.map((url) => fetch(url).then((resp) => resp.text()))).then((texts) => {
            setState((st) => ({
                ...st,
                arr_facilities: eval(texts[0]),
                mapLocation: eval(texts[1])
            }));
        });
    }, []);

    // when mapLocation finishes loading, compute current location distances once
    useEffect(() => {
        if (state.mapLocation && state.mapLocation.length) {
            fetchCurrentLocation();
        }
    }, [state.mapLocation, fetchCurrentLocation]);

    // initialize map whenever tempFilterList changes (we will refactor this later to avoid re-creating the map)
    const initMap = useCallback(() => {
        let isLastEventIsClicked = false;
        const map = new google.maps.Map(document.getElementById('map'), {
            zoom: state.zoom,
            center: { lat: state.currentLat, lng: state.currentLang }
        });

        const infoWindow = new google.maps.InfoWindow({
            content: '',
            disableAutoPan: true
        });

        infoWindow.addListener('closeclick', () => {
            isLastEventIsClicked = false;
        });

        let markers = state.tempFilterList.map((position, i) => {
            const label = '';
            let locatinAddress = `${position[2]},${position[3]}\n${position[4]},${position[5]}(${position[6]})`;
            const contentString =
                '<div>' +
                `<div>
                        <h2>${position[1]}</h2>
                    </div>` +
                `<div>
                        <p>
                          <b>Address:-</b> <a href="http://maps.google.com?q=${locatinAddress}" target="_blank">${locatinAddress}</a>
                        </p>
                        <p><b>Tel:-</b> <a href="tel:${position[7]}">${position[7]}</a></p>
                    </div>` +
                '</div>';

            const marker = new google.maps.Marker({
                position: { lat: +position[8], lng: +position[9] },
                label,
                icon: { url: position[11], size: { width: 40, height: 80 }, anchor: { x: 15, y: 50 }, scaledSize: { width: 25, height: 45 } }
            });

            marker.addListener('click', () => {
                isLastEventIsClicked = true;
                infoWindow.setContent(contentString);
                infoWindow.open(map, marker);
            });

            marker.addListener('mouseover', function () {
                if (!isLastEventIsClicked) {
                    infoWindow.setContent(contentString);
                    infoWindow.open(map, marker);
                }
            });

            marker.addListener('mouseout', function () {
                if (!isLastEventIsClicked) {
                    infoWindow.close();
                }
            });

            return marker;
        });

        markers.push(
            new google.maps.Marker({
                position: { lat: state.currentLat, lng: state.currentLang },
                label: '',
                icon: { url: vehcileCategoriesLogo, size: { width: 50, height: 100 }, anchor: { x: 15, y: 50 }, scaledSize: { width: 40, height: 55 } }
            })
        );
        new MarkerClusterer({ markers, map });
    }, [google, state.tempFilterList, state.currentLat, state.currentLang, state.zoom, vehcileCategoriesLogo]);

    useEffect(() => {
        if (google && state.tempFilterList) {
            initMap();
        }
    }, [state.tempFilterList, initMap, google]);

    // inputChange — stable callback that does robust facility parsing
    const inputChange = useCallback(
        (id) => (e) => {
            const { name, checked } = e.target;
            setState((st) => {
                let tempServiceFacList = [...st.facilitiId];

                if (checked) {
                    tempServiceFacList.push(id);
                } else {
                    const tempIndex = tempServiceFacList.findIndex((q) => q == id);
                    if (tempIndex > -1) tempServiceFacList.splice(tempIndex, 1);
                }

                let tempFilterList = [];
                if (tempServiceFacList.length > 0) {
                    st.FilterList.forEach(function (n) {
                        // robust facility parsing: handle "", "\"3\"", or "1,3,5"
                        let facilitiesRaw = n[10] || '';
                        // strip wrapping quotes if any
                        facilitiesRaw = facilitiesRaw.replace(/^"|"$/g, '');
                        const facilityIds = facilitiesRaw
                            .split(',')
                            .map((f) => f.trim())
                            .filter(Boolean);
                        const chekExist = tempServiceFacList.find((l) => facilityIds.includes(String(l)));
                        if (chekExist) {
                            tempFilterList.push(n);
                        }
                    });
                } else tempFilterList = [...st.FilterList];

                return { ...st, [name]: checked, facilitiId: tempServiceFacList, tempFilterList: tempFilterList };
            });
        },
        []
    );

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setState((st) => ({ ...st, [name]: value }));
    }, []);

    const handleEnter = useCallback(
        (e) => {
            if (e.key === 'Enter') {
                fetchCurrentLocation();
                setState((st) => ({ ...st, zoom: 12 }));
            }
        },
        [fetchCurrentLocation]
    );

    const getLocation = useCallback(() => {
        props.updateLocation(state.location);
    }, [props, state.location]);

    const searchHandle = useCallback(() => {
        fetchCurrentLocation();
        setState((st) => ({ ...st, zoom: 12 }));
    }, [fetchCurrentLocation]);

    // memoize the facility nodes to avoid mapping on every render; checked computed from canonical facilitiId
    const facilitiesNodes = useMemo(() => {
        return state.arr_facilities.map((f) => {
            const key = f[0];
            const name = f[1].trim();
            const checked = state.facilitiId.includes(f[0]);
            return (
                <Grid item xs={12} key={key}>
                    <FormControlLabel control={<Checkbox checked={checked} onChange={inputChange(f[0])} name={name} />} label={f[1]} />
                </Grid>
            );
        });
    }, [state.arr_facilities, state.facilitiId, inputChange]);

    return (
        <div style={{ height: '100%' }}>
            <Grid container spacing={2} style={{ height: '100%' }}>
                <Grid xs={2} item>
                    <Grid container spacing={1}>
                        <Grid xs={12} item>
                            <InputText
                                autoFocus={true}
                                placeholder="Post Code"
                                value={state.location}
                                onChange={handleChange}
                                onKeyDown={handleEnter}
                                name="location"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CustomIconButton toolTipTitle="Get location" onClick={searchHandle} icon={SearchIcon} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                        {props.updateLocation && (
                            <Grid xs={12} item>
                                <SecondaryButton onClick={getLocation}>Submit</SecondaryButton>
                            </Grid>
                        )}
                    </Grid>

                    <Grid container>
                        <Typography variant="h6">Service Area Facilities</Typography>
                        {facilitiesNodes}
                    </Grid>
                </Grid>
                <Grid xs={10} item>
                    <div id="map">Loading...</div>
                </Grid>
            </Grid>
        </div>
    );
};
export default GetAgentLocation2;
